import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useCallback, useEffect } from 'react';
import { useCarousel } from '@magento/peregrine';
import { generateUrlFromContainerWidth } from '@magento/peregrine/lib/util/imageUtils';
import { MESSAGE_TYPES, VALID_SERVICE_WORKER_ENVIRONMENT, sendMessageToSW } from '@magento/peregrine/lib/util/swUtils';
export var useProductImageCarousel = function useProductImageCarousel(props) {
  var images = props.images,
      type = props.type,
      imageWidth = props.imageWidth;

  var _useCarousel = useCarousel(images),
      _useCarousel2 = _slicedToArray(_useCarousel, 2),
      carouselState = _useCarousel2[0],
      carouselApi = _useCarousel2[1];

  var activeItemIndex = carouselState.activeItemIndex,
      sortedImages = carouselState.sortedImages;
  var handlePrevious = carouselApi.handlePrevious,
      handleNext = carouselApi.handleNext,
      setActiveItemIndex = carouselApi.setActiveItemIndex;
  var handleThumbnailClick = useCallback(function (index) {
    setActiveItemIndex(index);
  }, [setActiveItemIndex]); // Whenever the incoming images changes reset the active item to the first.

  useEffect(function () {
    setActiveItemIndex(0);
  }, [images, setActiveItemIndex]);
  useEffect(function () {
    if (VALID_SERVICE_WORKER_ENVIRONMENT) {
      var urls = images.map(function (_ref) {
        var file = _ref.file;
        return new URL(generateUrlFromContainerWidth(file, imageWidth, type), location.origin).href;
      });
      sendMessageToSW(MESSAGE_TYPES.PREFETCH_IMAGES, {
        urls: urls
      }).catch(function (err) {
        console.error('Unable to send PREFETCH_IMAGES message to SW', err);
      });
    }
  }, [images, imageWidth, type]);
  var currentImage = sortedImages[activeItemIndex] || {};
  var altText = currentImage.label || 'image-product';
  return {
    currentImage: currentImage,
    activeItemIndex: activeItemIndex,
    altText: altText,
    handleNext: handleNext,
    handlePrevious: handlePrevious,
    handleThumbnailClick: handleThumbnailClick,
    sortedImages: sortedImages
  };
};